var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustShadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18.6,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6516 10.8899C15.3838 15.0396 10.7459 16.7483 8.67114 14.1852C5.25364 17.1144 1.83623 14.0632 2.56862 10.8899C1.10916 9.30868 0.684579 7.363 1.22626 5.88582C1.77166 4.39847 3.29466 3.38443 5.13168 3.20073C6.59639 0.515506 10.0138 0.027472 12.2106 3.20073C13.824 3.07174 15.5659 4.4586 16.1163 6.25215C16.6069 7.85059 16.0895 9.79718 14.6516 10.8899Z",
    stroke: "currentColor",
    strokeWidth: 1.69284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67046 6.13123V10.0368M8.67046 20.045V12.5999M8.67046 10.0368L11.4776 8.32813M8.67046 10.0368V12.5999M8.67046 12.5999L5.98535 11.0132",
    stroke: "currentColor",
    strokeWidth: 1.69284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustShadingIcon);
export default __webpack_public_path__ + "static/media/adjust-shading-icon.352dc368d43bc13c652a4fd220b2c31d.svg";
export { ForwardRef as ReactComponent };